import { getLocale } from '../user/device-info';

function formatNumber( number: number ): string {
    if ( !window.Intl || number === 0 ) {
        return number.toString();
    }

    if ( !window.numberFormat ) {
        window.numberFormat = new Intl.NumberFormat( getLocale(), {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
            useGrouping: true,
        } );
    }

    return window.numberFormat.format( number );
}

export {
    formatNumber,
};
